module.exports = __webpack_public_path__ + "img/Avatar-8.4499135d.svg";